export const RESPONSE_STATUS = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    PRECONDITION_FAILED: 412,
    SERVICE_ERROR: 500,
    CX_RESPONSE: 200,
};

export const PRECONDITION_CODE = {
    EMAIL_TAKEN: 'email_already_exists',
};

export const CX_STATUS = {
    UNAVAILABLE: 'unavailable',
    UNKNOWN_ERROR: 'unknown_error',
    EMAIL_TAKEN: 'email_already_exists',
    USERNAME_TAKEN: 'username_already_exists',
    TELEGRAM_INVALID: 'telegram_invalid',
    PROCESSING: 'processing',
};
